<template>
  <div class="mobile-center-comp">
    <div class="left-comp" @click="showNavBar">
      <template v-if="!appNavBarStatus">
        <span></span>
        <span></span>
        <span></span>
      </template>
      <template v-else>
        <i class="el-icon-close"></i>
      </template>
    </div>
    <div class="center-comp" v-if="!isShowSelect"></div>
    <div class="right-comp" v-if="!isShowSelect">
      <i class="el-icon-search" @click="isShowSelect = true"></i>
    </div>
    <searchComp v-if="isShowSelect"></searchComp>
  </div>
</template>

<script>
import searchComp from './searchComp'

export default {
  name: 'mobileCenterComp',
  components: {
    searchComp
  },
  computed: {
    appNavBarStatus() {
      return this.$store.state.app.showMobileStatus
    }
  },
  data() {
    return {
      isShowSelect: false,
    }
  },
  methods: {
    showNavBar() {
      this.$store.commit('app/TOGGLE_MOBILE_BAR', !this.appNavBarStatus)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-center-comp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 p2r(16px) p2r(19px);

  .left-comp {
    width: p2r(20px);
    display: flex;
    flex-wrap: wrap;

    span {
      width: p2r(20px);
      height: p2r(3px);
      background: $bloodRed;

      &:nth-of-type(2) {
        width: p2r(20px);
        margin: p2r(6px) 0;
      }
    }

    i {
      display: inline-block;
      width: p2r(25px);
      height: p2r(25px);
      font-size: p2r(25px);
      color: $bloodRed;
    }
  }

  .center-comp {
    width: p2r(171px);
    height: p2r(29px);
    background: url("../../assets/img/logo.png") no-repeat;
    background-size: 100% 100%;
  }

  .right-comp {
    text-align: center;
    width: p2r(25px);
    height: p2r(25px);
    line-height: p2r(25px);
    background: $bloodRed;

    i {
      color: #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/mobileCenterComp.vue